import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import TeamPage from './TeamPage.js';

export default WithGASetup(TeamPage, AuthContext);
